import { IModel, IAttribute } from '../base/annotation';
import { Metamodel } from 'app/model/base/model';

import { TabularTypeDataset } from './tabular-type.dataset';
import { SapOpenHubLinkedService } from '../linkedservice/sap-open-hub.linkedservice';
import { adfModelTypeMap } from '../../registries/consts/adf-model-type-map-const';
import { format } from 'app/shared/utils/string.util';

@Metamodel.model({
    name: adfModelTypeMap.sapOpenHub.datasetType,
    display: [
        format(stringResources.ModelName_DatasetTemplate, stringResources.SapOpenHub_DisplayText),
        format(stringResources.ModelName_DatasetsTemplate, stringResources.SapOpenHub_DisplayText)
    ],
    constraints: {
        linkedService: {
            model: SapOpenHubLinkedService.MODEL // Linked service redefined
        }
    }
})
export class SapOpenHubTableDataset extends TabularTypeDataset {
    public static readonly MODEL: IModel;
    public static readonly EXCLUDE_LAST_REQUEST: IAttribute;
    public static readonly BASE_REQUEST_ID: IAttribute;

    @Metamodel.attribute({
        display: stringResources.ModelName_BaseRequestId,
        association: 'BASE_REQUEST_ID',
        templatable: true
    })
    public baseRequestId?: number;

    @Metamodel.attribute({
        display: stringResources.ModelName_ExcludeLastRequest,
        association: 'EXCLUDE_LAST_REQUEST',
        templatable: true
    })
    public excludeLastRequest?: boolean = true;

    public constructor(name?: string, description?: string) {
        super(name, description);
    }
}
